<template>
    <div>
        <o-table ref="tableList" :enable-view="false" default-sort-by="id" default-sort-by-direction="desc" :title="$t('sandoz.kukos')"
                 :url="'/api/kukos?include=user,approval_feedback_user,approval_steps'">
            <template slot="filter">
                <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
                    <o-filter-select :items="userList" :title="$t('sandoz.requestor')" column="user_id" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="kukoTypes" :title="$t('sandoz.kuko_type')" column="kuko_type" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="statuses" :title="$t('sandoz.status')" column="status" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="channels" :title="$t('sandoz.channel')" column="channel" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="accountCategories" :title="$t('sandoz.account_category')" column="account_category" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="conditionCategories" :title="$t('sandoz.condition_category')" column="condition_category" value-field="id" text-field="name"></o-filter-select>
                    <o-filter-select :items="years" :title="$t('sandoz.kuko_year')" column="kuko_year" value-field="value" text-field="text"></o-filter-select>
                    <o-filter-text :title="$t('sandoz.customer')" column="address1" :prepend-percentage="true"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.customer_external_id')" column="external_id" :prepend-percentage="true"></o-filter-text>
                    <o-filter-text :title="$t('sandoz.kuko_no')" column="id"></o-filter-text>
                </o-filter>
            </template>
            <template slot="head">
                <o-table-header column="id" :sortable="true">{{ $t('sandoz.kuko_no') }}</o-table-header>
                <o-table-header column="kuko_type" :sortable="true">{{ $t('sandoz.kuko_type') }}</o-table-header>
                <o-table-header column="customer" :sortable="false">{{ $t('sandoz.customer') }}</o-table-header>
                <o-table-header column="account_category">{{ $t('sandoz.account_category') }}</o-table-header>
                <o-table-header column="kuko_date" :sortable="true">{{ $t('sandoz.request_date') }}</o-table-header>
                <o-table-header column="status" :sortable="true">{{ $t('sandoz.status') }}</o-table-header>
                <o-table-header column="next_approver" :sortable="false">{{ $t('sandoz.next_approver') }}</o-table-header>
                <o-table-header column="user.name" :sortable="false">{{ $t('sandoz.requestor') }}</o-table-header>
                <o-table-header column="kuko_year" :sortable="true">{{ $t('sandoz.kuko_year') }}</o-table-header>
            </template>
            <template slot="body" slot-scope="props">
                <td>{{props.item.id}}</td>
                <td>
                  <span v-if="props.item.kuko_type == 'condition'">
                    {{$t('sandoz.conditions')}}
                  </span>
                  <span v-if="props.item.kuko_type == 'payment_terms'">
                    {{$t('sandoz.payment_terms')}}
                  </span>
                  <span v-if="props.item.kuko_type == 'chargebacks'">
                    {{$t('sandoz.chargebacks')}}
                  </span>
                </td>
                <td>
                  {{props.item.address1}}
                </td>
                <td>
                  <template v-if="props.item.account_category == 'individual_account'">{{$t('sandoz.individual_account')}}</template>
                  <template v-if="props.item.account_category == 'buying_group'">{{$t('sandoz.buying_group')}}</template>
                  <template v-if="props.item.account_category == 'smart_selection'">{{$t('sandoz.smart_selection')}}</template>
                  <template v-if="props.item.account_category == 'chargeback_condition'">{{$t('sandoz.chargeback_condition')}}</template>
                </td>
                <td>{{props.item.kuko_date | formatDate}}</td>
                <td>
                  <span v-if="props.item.legacy_kuko" class="badge badge-info">{{$t('sandoz.legacy')}}</span>
                  <template v-else>
                    <template v-if="props.item.status">
                      <span v-if="props.item.status == 'Feedback' || props.item.status == 'Rejected'" class="text-danger">
                        {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
                        <fa icon="info-circle" @click.prevent="showFeedback(props.item)"></fa>
                      </span>
                      <span v-else>
                        {{ $t('sandoz.' + props.item.status.match(/[A-Z][a-z]+/g).join("_").toLowerCase()) }}
                      </span>
                    </template>
                  </template>
                </td>
                <td>
                  <template v-for="(approvalStep,approvalStepIndex) in props.item.approval_steps.data.filter(a => !a.approval_date)">
                    <span v-if="approvalStepIndex==0" :key="approvalStepIndex">
                      {{approvalStep.approval_role}}
                    </span>
                  </template>
                </td>
                <td>{{props.item.user ? props.item.user.data.name : ''}}</td>
                <td>{{props.item.kuko_year}}</td>
            </template>
            <template slot="body-controls" slot-scope="props">
              <td class="text-right">
                <div class="btn-group btn-group-sm" role="group" aria-label="edit controls">
                  <b-dropdown v-if="user.is_super_user && !props.item.legacy_kuko && props.item.status !== 'Draft'"
                              :popper-opts="{ positionFixed: true }" boundary="window" variant="secondary" size="sm" no-caret>
                    <template #button-content>
                      <fa icon="wand-magic-sparkles"/>
                    </template>
                    <b-dropdown-item href="#" @click.prevent="resetToDraft(props.item.id)">
                      {{ $t('sandoz.reset_to_draft') }}
                    </b-dropdown-item>
                  </b-dropdown>
                  <b-btn @click="cloneKuko(props.item.id)" class="btn btn-secondary" v-if="!props.item.legacy_kuko">
                    <fa icon="clone"/>
                  </b-btn>
                  <o-delete method="delete" v-if="!!user.is_super_user || (props.item.status === 'Draft'  && props.item.user_id === user.id)" :url="'/api/kukos/' + props.item.id" v-on:action-executed="$refs.tableList.search"></o-delete>
                  <router-link :to="{ path: $route.path + '/' + props.item.id }" class="btn btn-primary">
                    <fa icon="pencil-alt"/>
                  </router-link>
                </div>
              </td>
            </template>
        </o-table>
    </div>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import { contractYears } from '../../utils/contractYear'

export default {
  data: () => ({
    userList: [],
    statuses: [],
    showHide: [],
    kukoTypes: [],
    accountCategories: [],
    conditionCategories: [],
    channels: [],
    years: []
  }),
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },
  created() {
    this.statuses.push({id: 'Draft', name: this.$i18n.t('sandoz.draft')})
    this.statuses.push({id: 'Committed', name: this.$i18n.t('sandoz.committed')})
    this.statuses.push({id: 'Approved', name: this.$i18n.t('sandoz.approved')})
    this.statuses.push({id: 'Feedback', name: this.$i18n.t('sandoz.feedback')})
    this.statuses.push({id: 'Rejected', name: this.$i18n.t('sandoz.rejected')})
    this.statuses.push({id: 'Legacy', name: this.$i18n.t('sandoz.legacy')})
    this.statuses.push({id: 'Stored', name: this.$i18n.t('sandoz.stored')})
    this.statuses.push({id: 'Cancelled', name: this.$i18n.t('sandoz.cancelled')})

    this.kukoTypes.push({id: 'condition', name: this.$i18n.t('sandoz.conditions')})
    this.kukoTypes.push({id: 'payment_terms', name: this.$i18n.t('sandoz.payment_terms')})
    this.kukoTypes.push({id: 'chargebacks', name: this.$i18n.t('sandoz.chargebacks')})

    this.accountCategories.push({id: 'individual_account', name: this.$i18n.t('sandoz.individual_account')})
    this.accountCategories.push({id: 'buying_group', name: this.$i18n.t('sandoz.buying_group')})
    this.accountCategories.push({id: 'chargeback_condition', name: this.$i18n.t('sandoz.chargeback_condition')})

    this.conditionCategories.push({id: 'otcProducts', name: this.$i18n.t('sandoz.products')})
    this.conditionCategories.push({id: 'specialOrder', name: this.$i18n.t('sandoz.special_order')})
    this.conditionCategories.push({id: 'materialGroup', name: this.$i18n.t('sandoz.material_group')})
    this.conditionCategories.push({id: 'profitCenter', name: this.$i18n.t('sandoz.profit_center')})

    this.channels.push({id: 'APO', name: 'APO'})
    this.channels.push({id: 'SD', name: 'SD'})
    this.channels.push({id: 'HOSP', name: 'HOSP'})
    this.channels.push({id: 'IMMUNO', name: 'IMMUNO'})
    this.channels.push({id: 'High Specialty', name: 'High Specialty'})
    this.channels.push({id: 'KAM', name: 'KAM'})
    this.channels.push({id: 'Wholesaler', name: 'Wholesaler'})
    this.channels.push({id: 'Market Access', name: 'Market Access'})

    this.showHide.push({id: 'show', name: this.$i18n.t('sandoz.show')})
    this.showHide.push({id: 'hide', name: this.$i18n.t('sandoz.hide')})

    this.years = contractYears()
  },
  mounted() {
    axios.get('/api/system/users?filter%5Bactive%5D=1%25&sortBy=name&per_page=99999').then((response) => {
      this.userList = response.data.data
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    showFeedback(item) {
      window.alert(item.approval_feedback_user.data.name + ': ' + item.approval_feedback)
    },
    async resetToDraft(kukoId) {
      try {
        await axios.post(`/api/kukos/${kukoId}/reset-to-draft`)
        this.$refs.tableList.search()
      } catch (error) {
        console.error(error)
      }
    },
    async cloneKuko(kukoId) {
      let url = `/api/kukos/${kukoId}?include=user,approval_feedback_user,wholesalers,wholesalers.wholesaler,condition_product_groups,condition_product_groups.kuko_product_group,condition_products,condition_products.kuko_product,condition_special_products,condition_special_products.kuko_product,condition_product_rebates,condition_product_group_rebates,condition_special_product_rebates,approval_steps,approval_steps.trigger_notification,otc_product_attachments,special_order_attachments,customers`

      const { data: newObj } = await axios.get(url);

      delete newObj.id
      delete newObj.approval_steps
      delete newObj.approval_finished_notification_sent_at
      delete newObj.approval_stored_notification_sent_at
      delete newObj.contracts

      newObj.user_id = this.user.id

      let clearObjects = ['condition_product_groups', 'condition_products', 'wholesalers', 'condition_special_products', 'condition_product_rebates',
        'condition_special_product_rebates', 'condition_product_group_rebates', 'smart_selection_conditions', 'otc_product_attachments', 'special_order_attachments',
        'customers']

      clearObjects.forEach(o => {
        newObj[o].forEach(r => {
          delete r.id
          delete r.kuko_id
        })
      })

      newObj.status = 'Draft'
      newObj.file_name = [...Array(30)].map(() => Math.random().toString(36)[2]).join('')

      let today = new Date();
      let month = (today.getMonth() + 1).toString().padStart(2, "0");
      let day = today.getDate().toString().padStart(2, "0");
      let date = today.getFullYear()+'-'+month+'-'+day;
      newObj.kuko_date = date
      newObj.kuko_year = today.getFullYear()

      // Fetch a customer data from warhouse table
      if(newObj.account_category === "individual_account" && (newObj.external_id !== '' || newObj.external_id !== null)) {
        await this.fetchReplaceCustomer(newObj)
      }

      const { data: newResponse } = await axios.get(`/api/kukos/new`);
      newObj.approval_steps = newResponse.approval_steps;

      if (newObj.channel !== 'Market Access') {
        newObj.approval_steps = newObj.approval_steps.filter(
          step => step.approval_role !== 'Head of Market Access'
        );
      } else {
        newObj.approval_steps = newObj.approval_steps.filter(
          step => step.approval_role !== 'Business'
        );
      }


      const { data: finalResponse } = await axios.post(`/api/kukos/new`, newObj);

      this.$router.push({
        name: 'sandoz.kuko.detail',
        params: { id: finalResponse.id }
      })
    },
    async fetchReplaceCustomer(newObj) {

      var data = { is_apo_one: false, multipleContractsPerPractice : false, ownContract : false, q : newObj.external_id}

      try {
        const response = await axios.post(`/api/sandoz/ice-peak/contracts/search-addresses`, data);

        const responseData = response.data;

        if (responseData) {
          const address = responseData.data[0];

          newObj.sap_id = address.org_sap_id;
          newObj.account_sub_type = address.org_sub_type;
          newObj.primary_parent = address.parent_full_name;
          newObj.address1 = address.org_full_name;
          newObj.address2 = address.org_street;
          newObj.address3 = address.org_zip_code + " " + address.org_city;
        }

        return newObj;
      } catch (error) {
        throw error;
      }
    }
  }
}
</script>
